import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import AppService from 'src/AppService';
import { StarRating } from 'src/easyclaim.app.components';

import { FinishedV2 } from './FinishedV2';
import styles from './styles/UpdatedFeedbackScreen.module.css';

interface UpdatedFeedbackScreenProps {
	feedbackMaxLength: number;
	appService: AppService;
}

export const UpdatedFeedbackScreen = ({
	feedbackMaxLength,
	appService,
}: UpdatedFeedbackScreenProps) => {
	const intl = useIntl();
	const [error, setError] = useState<string | null>(null);
	const [rating, setRating] = useState(appService.app.state.easyClaimCase?.feedbackRating ?? 0);
	const [feedback, setFeedback] = useState(
		appService.app.state.easyClaimCase?.feedbackComment ?? ''
	);

	const onFeedbackChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		const value = e.target.value;

		setFeedback(value);
		setError(
			value.length >= feedbackMaxLength
				? intl.formatMessage({ id: 'feedback.error.maxLength' }, { maxLength: feedbackMaxLength })
				: null
		);
		const easyClaimCase = appService.app.state.easyClaimCase!;

		easyClaimCase.feedbackComment = value;
		appService.app.setState({ easyClaimCase });
	};

	const onRatingChange = (newRating: number) => {
		setRating(newRating);
		const easyClaimCase = appService.app.state.easyClaimCase!;

		easyClaimCase.feedbackRating = newRating;
		appService.app.setState({ easyClaimCase });
	};

	return (
		<div className={`main-container ${styles.feedbackScreen}`}>
			<div className={styles.topSection}>
				<FinishedV2 />
				<div className={styles.feedbackContainer}>
					<h2>
						<FormattedMessage id="feedback.title" />
					</h2>
					<h3 id="feedbackMessage">
						<FormattedMessage id="feedback.message" />
					</h3>
					<StarRating
						className="updatedRating"
						range={5}
						rating={rating ?? undefined}
						onChange={onRatingChange}
					/>
				</div>
				<h3>
					<FormattedMessage id="feedback.helpImprove" />
				</h3>
			</div>
			<div className={styles.textareaWrapper}>
				<textarea
					className={styles.feedbackArea}
					value={feedback}
					onChange={onFeedbackChange}
					maxLength={feedbackMaxLength}
				/>
				{error && <div className={styles.error}>{error}</div>}
			</div>
		</div>
	);
};
